export function hasContent (str: string | undefined): boolean {
  return str !== undefined && str.length > 0
}
